
interface Form {
  name: string;
  tag: string;
  style: number;
  status: string;
}
import { Component, Vue } from 'vue-property-decorator';
import { STATUS_LIST } from '@/constants';
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/boss/ruan/cases`,
  sort: `${FCAPI}/boss/ruan/cases/sort`,
  style_list: `${FCAPI}/boss/ruan/style/name`,
};
@Component
export default class RuanStyleList extends Vue {
  is_loading = false;
  form: Form = {
    name: '',
    tag: '',
    style: 0,
    status: '0',
  };
  tag_list = [];
  style_list = [];
  style_list_obj: any = {};
  status_list = STATUS_LIST;
  table_data = {};
  page = 1;

  handChangePaging(pagination: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  paginationOption(data: Pagination<any>) {
    return {
      total: data.total || 0,
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  tagText(tag: any) {
    const tag_list = tag.split(',');
    let text = '';
    tag_list.forEach((item: any) => {
      text += `#${item} `;
    });
    return text;
  }

  submit() {
    this.query(1);
  }

  async onChangeSort(item: any) {
    const res = await this.$axios.put(`${API.sort}/${item.id}`, {
      id: item.id,
      sort: item.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('修改成功');
    await this.query(this.page);
  }

  async onChangeOnlineStatus(item: any) {
    const res = await this.$axios.get(`${API.query}/${item.id}/edit`, {
      params: {
        is_show: item.is_show === 1 ? 2 : 1,
      },
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.query(this.page);
  }

  async getStyleData() {
    const res = await this.$axios.get(API.style_list);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.style_list = data;
    this.style_list.forEach((item: any) => {
      this.style_list_obj[item.id] = item.name;
    });
  }

  async query(page = 1) {
    this.page = page;
    const form = this.form;
    const send_data: any = {
      name: form.name,
      tag: form.tag,
    };
    if (form.style) {
      send_data.style_id = form.style;
    }
    if (form.status) {
      send_data.is_show =
        form.status === 'on' ? 1 : form.status === 'off' ? 2 : '';
    }
    const res = await this.$axios.get(API.query, { params: send_data });
    if (res.data.status !== 200) {
      this.table_data = {};
      return;
    }
    const data = res.data.data || {};
    this.table_data = data;
  }

  clearForm() {
    const form = this.form;
    form.name = '';
    form.tag = '';
    form.style = 0;
    form.status = '0';
  }

  async created() {
    await this.getStyleData();
    await this.query(1);
  }
}
